const pageContainerStyle = {
  maxWidth: '2560px',
  m: '0 auto',
};

export default pageContainerStyle;
